import { getPromoMetricByNameKeyName } from 'components/molecules/TradePromoOptimization/tpoHelperMethods';
import { TpoMessages } from 'constants/tpo';
import { ProductPPG, PromoConfigDictionary, PromoEvent } from 'types/tradePromoOptimization';
import { PromotionTypes, tpoPromoMetricKeys } from 'utils/Enums';
import { sendNotification } from 'utils/helperMethods';

export const validateTPOAdjustedBaseUnits = (
    selectedEventInfo: PromoEvent | null,
    promoConfigDictionary: PromoConfigDictionary,
) => {
    const currentPromo = selectedEventInfo?.currentPromoTactic;
    if (!currentPromo) return false;
    const negativeTPOUnitsPPGs: string[] = [];
    currentPromo?.ppgs
        ?.filter((p: ProductPPG) => p.isSelected)
        .forEach((ppg: ProductPPG) => {
            const adjustedBaseUnits = getPromoMetricByNameKeyName(
                promoConfigDictionary,
                tpoPromoMetricKeys.TPO_ADJUSTED_BASE_UNITS,
            );

            const negativeTPO = Number(ppg.metrics.find((m) => m.id === adjustedBaseUnits.id)?.value ?? 0) < 0;
            if (negativeTPO) {
                negativeTPOUnitsPPGs.push(ppg.name);
            }
        });

    if (negativeTPOUnitsPPGs.length > 0) {
        sendNotification('error', TpoMessages.error.TPO_ADJUSTED_BASE_UNITS_CANNOT_BE_NEGATIVE(negativeTPOUnitsPPGs));
        return true;
    }

    return false;
};

export const validateSpendsForMdfIsmPromotions = (
    selectedEventInfo: PromoEvent | null,
    promoConfigDictionary: PromoConfigDictionary,
) => {
    if (
        !selectedEventInfo?.currentPromoTactic ||
        ![PromotionTypes.SM_MDF, PromotionTypes.SM_ISM].includes(selectedEventInfo?.currentPromoTactic?.promoType ?? 0)
    ) {
        return false;
    }

    const firstPPG = selectedEventInfo?.currentPromoTactic?.ppgs[0];
    if (!firstPPG) {
        return false;
    }

    // Check if any of the fixed spend details are selected
    if (
        !firstPPG?.spendDetails
            .filter((sd) => promoConfigDictionary.spendMetrics[sd.id]?.editable)
            .some((sd) => sd.isSelected)
    ) {
        sendNotification('error', TpoMessages.error.FIXED_SPENDS_FOR_MDF_ISM_PROMOTIONS);
        return true;
    }

    return false;
};
